import { collection, getDocs, query, where } from "firebase/firestore";
import { apiErrorHandler } from "../utilities/utitlityFunctions";
const TTL_MS = 45_000;

let cache = { email: null, data: null, fetchedAt: 0 };

export function invalidateSaccoMemberCache() {
  cache = { email: null, data: null, fetchedAt: 0 };
}

export async function fetchSaccoMemberByEmail(db, userEmail) {
  if (!userEmail) {
    return {};
  }
  const now = Date.now();
  if (
    cache.email === userEmail &&
    now - cache.fetchedAt < TTL_MS &&
    cache.data
  ) {
    return cache.data;
  }

  try {
    const q = query(
      collection(db, "SaccoMembers"),
      where("email", "==", userEmail),
    );
    const querySnapshot = await getDocs(q);
    const results = [];
    querySnapshot.forEach((docSnap) => {
      results.push({ id: docSnap.id, ...docSnap.data() });
    });
    const member = results[0] || {};
    cache = { email: userEmail, data: member, fetchedAt: now };
    return member;
  } catch (error) {
    apiErrorHandler(null, `An error occured while fetching user: ${error}`);
    return {};
  }
}
